import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FrameComponent } from "../../common/FrameComponent";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { selectAgentLoading, selectAgentValue } from "./redux/selectors";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { AppLoading } from "../../shared/components/AppLoading";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { approvedAgentTgBotAction, createAgentAction } from "./redux/actions";
import { CreateAgentModal } from "./Components/CreateAgentModal";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { AppUnderlinedTitle } from "../../shared/components/AppUnderlinedTitle";
import { RenameObjectInput } from "../../common/RenameObjectInput";
import { AppIconButton } from "../../shared/components/AppIconButton";
import { ShieldCheckIcon } from "../../shared/icons/ShieldChackIcon";
import { ApprovedTgBotModal } from "./Components/ApprovedTgBotModal";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const Agents = ({ className }: Props) => {
  const dispatch = useAppDispatch();
  const agentValue = useAppSelector(selectAgentValue);
  const isAgentLoading = useAppSelector(selectAgentLoading);
  const { selectedId } = useStorageSelectors("krab");
  const { selectedObject } = useStorageSelectors("krab");
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  const src = useMemo(() => {
    return agentValue?.agent_object?.iframe_src;
  }, [agentValue, selectedId]);

  const handleCreateAgent = (objectName: string, agentName: string) => {
    dispatch(createAgentAction({ objectName, agentName }));
  };

  const handleApproved = (uid: string, token: string) => {
    dispatch(approvedAgentTgBotAction({ uid, token }));
  };

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("agents.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={() => handleOpenModal("create_agent_modal", null, "root")}
      />
    );
  }

  return (
    <div className={styles["agent-container"]}>
      <AppUnderlinedTitle
        leftContent={<RenameObjectInput inputType={"input"} service={"krab"} />}
        className={styles["header"]}
      >
        <AppIconButton
          onClick={() => handleOpenModal("approved_tg_bot_modal", null)}
        >
          <ShieldCheckIcon />
        </AppIconButton>
      </AppUnderlinedTitle>
      {isAgentLoading ? (
        <AppLoading className={styles.loader} />
      ) : (
        <FrameComponent src={src ?? ""} />
      )}
      <CreateAgentModal
        subtype={"root"}
        handleCreateAgent={handleCreateAgent}
        closeModal={handleCloseModal}
      />
      <ApprovedTgBotModal
        closeModal={handleCloseModal}
        handleApprovedTgBot={handleApproved}
      />
    </div>
  );
};
